export const getStoredUser = () => {
  const raw = localStorage.getItem('user');
  if (!raw) return {};
  try {
    return JSON.parse(raw);
  } catch (error) {
    console.error('Unable to parse stored user payload', error);
    return {};
  }
};

export const getAccountType = (user) => {
  if (!user) return 'standard';
  const accountType = user.account_type || user.accountType;
  if (accountType) return accountType;
  const role = (user.role || '').toLowerCase();
  if (role.startsWith('msp') || role === 'tenantreadonly') {
    return 'msp';
  }
  return 'standard';
};

export const getAuthState = () => {
  const token = localStorage.getItem('access_token');
  const user = getStoredUser();
  const role = user.role || '';
  const accountType = getAccountType(user);
  const tenantId = user.tenant_id || user.tenantId || '';

  return {
    token,
    user,
    role,
    accountType,
    tenantId,
    isAuthenticated: !!token,
  };
};

/** Dispatch custom event so App can refresh auth state (storage event doesn't fire in same tab) */
export const notifyAuthChange = () => {
  window.dispatchEvent(new CustomEvent('auth-change'));
};
